var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAnnouncementActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04717 17H20.1586V2H6.55114C4.53523 2 4.03125 3.33333 4.03125 4V19C4.03125 17.4 5.37519 17 6.04717 17Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03125 19.5V4.5C4.03125 3.83696 4.29674 3.20107 4.76931 2.73223C5.24188 2.26339 5.88283 2 6.55114 2H19.1506C19.4179 2 19.6743 2.10536 19.8633 2.29289C20.0524 2.48043 20.1586 2.73478 20.1586 3V21C20.1586 21.2652 20.0524 21.5196 19.8633 21.7071C19.6743 21.8946 19.4179 22 19.1506 22H6.55114C5.88283 22 5.24188 21.7366 4.76931 21.2678C4.29674 20.7989 4.03125 20.163 4.03125 19.5ZM4.03125 19.5C4.03125 18.837 4.29674 18.2011 4.76931 17.7322C5.24188 17.2634 5.88283 17 6.55114 17H20.1586",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06445 13L12.0963 6L16.1281 13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17188 11H14.9172",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnnouncementActive);
export default __webpack_public_path__ + "static/media/ic-announcement-active.3f1fb2c3f741fb3968a5717bfdac473a.svg";
export { ForwardRef as ReactComponent };